import { SimpleGuard } from 'interfaces/guards'
import { GetCCShipmentAddressAction } from 'components/features/creditCard/creditCardStore/actions'
import { shipmentAddressSelector } from 'components/features/creditCard/creditCardStore/selectors'


export const ccShipmentAddressGuard: SimpleGuard = {
  name: `Card Shipment Address Guard`,
  checker: (state) => {
    return shipmentAddressSelector(state) !== null
  },
  loader: (dispatch) => {
    dispatch(new GetCCShipmentAddressAction())
  },
}
